import { useBotbRAFContext } from "@/app/(custom-header)/botb-refer-a-friend/context";

function QualifyProgress({ inline }: { inline?: boolean }) {
  const { rafStatus, loading, minimumReferralsForGrantPrize, calculatePercentage } = useBotbRAFContext();

  const t: any = {
    title: ` more friends to qualify.`,
    qualified: `<strong className="text-[13px] leading-[18px]">${loading ? "" : rafStatus.rafflePlayersQualified}</strong> Players Qualified`,
  };

  return (
    <div
      className={`flex w-full gap-2 font-jost ${inline ? "justify-between items-end max-lg:mt-0.5" : "flex-col items-start"}`}>
      <div className={`flex flex-col gap-2 ${inline ? "" : "w-full"}`}>
        <div className={"self-stretch text-[#696971] text-xs font-medium leading-4 lg:text-sm lg:leading-5"}>
          <span className={`${loading ? "blur-[4px] opacity-50" : ""}`}>
            {loading
              ? "0"
              : minimumReferralsForGrantPrize -
                (rafStatus.referredFriends > minimumReferralsForGrantPrize
                  ? minimumReferralsForGrantPrize
                  : rafStatus.referredFriends)}
          </span>{" "}
          {t.title}
        </div>
        <div className={"flex min-w-[131px] h-2 flex-col items-start gap-2.5 self-stretch bg-[#EFEFEF] rounded-full"}>
          {!loading && (
            <div
              className={"bg-primary rounded-full h-full"}
              style={{ width: calculatePercentage(rafStatus.referredFriends > 5 ? 5 : rafStatus.referredFriends, 5) }}
            />
          )}
        </div>
      </div>
      <div
        className={`self-stretch text-[#696971] text-xs lg:text-[13px] font-normal leading-4 lg:leading-[18px] ${inline ? "flex flex-col text-right shrink-0" : ""}`}
        dangerouslySetInnerHTML={{ __html: t.qualified }}
      />
    </div>
  );
}

export default QualifyProgress;
